import React from 'react';
import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { ThingToDoComponent, ThingToDoComponentProps } from '@apps/guest/packages/layout-engine/widgets/Custom/components/ThingToDo/ThingToDoComponent';
import { CustomThingToDoComponent } from '@apps/guest/packages/layout-engine/widgets/Custom/components/ThingToDo/CustomThingToDoComponent';
import { useLayout } from '@apps/guest/packages/layout-engine/layouts/LayoutProvider';
import { DesignLayoutType } from '@graphql/generated';

// Tip:
// This is the component that is rendered on the guest site.
export const ThingsToDoGuest = (props: GuestSiteComponentProps) => {
  const { layout } = useLayout();
  const componentDefaultLayout = layout === DesignLayoutType.brannan ? 'fullRow' : 'widget';

  const data: ThingToDoComponentProps = {
    id: props.jsonComponentData.containerContent.id,
    title: props.jsonComponentData.containerContent.content.poi.title,
    category: props.jsonComponentData.containerContent.content.poi.category,
    description: props.jsonComponentData.containerContent.content.poi.description,
    image: props.jsonComponentData.containerContent.content.poi.image,
    url: props.jsonComponentData.containerContent.content.poi.url,
    sortOrder: 0,
    designType: componentDefaultLayout,
    location: props.jsonComponentData.containerContent.content.location.city || undefined,
  };

  return props.jsonComponentData.containerContent.content.poi.tours && props.jsonComponentData.containerContent.content.poi.tours.length > 0 ? (
    <ThingToDoComponent {...data} />
  ) : (
    <CustomThingToDoComponent {...data} />
  );
};
